module.exports = __webpack_public_path__ + "img/ehp_logo.5c82f59c.svg";